import { IUserProjectRoleModel } from '../../../../../../../../service/projectRole/entity/IUserProjectRoleModel';
import { IUserProjectRoleService } from '../../../../../../../../service/projectRole/entity/IUserProjectRoleService';
import { IRowContextMenuUI } from '../../../../../../../design/dataTable/parts/rowContextMenu/domain/IRowContextMenuUI';
import { RowContextMenuDomain } from '../../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuDomain';
import { IDataTableDomain } from '../../../../../../../design/dataTable/store/IDataTableDomain';
import { IMainLayoutDomainStore } from '../../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { UserProjectRoleContextMenuUI } from './UserProjectRoleContextMenuUI';

export class UserProjectRoleContextMenuDomain extends RowContextMenuDomain<IUserProjectRoleModel> {
  constructor({
    entityService,
    dataTableDomain,
    layoutDomain,
    ui,
  }: {
    entityService: IUserProjectRoleService;
    dataTableDomain: IDataTableDomain<IUserProjectRoleModel, any>;
    layoutDomain: IMainLayoutDomainStore;
    ui?: IRowContextMenuUI<IUserProjectRoleModel> | null;
  }) {
    super(entityService, dataTableDomain, layoutDomain, undefined, ui);
    this.ui = ui || new UserProjectRoleContextMenuUI(this);
  }
}
